exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thanks-check {\n  width: 33%;\n  height: auto;\n  margin-bottom: 15px; }\n\n.thanks-welcome-text {\n  text-align: center;\n  color: #9b9b9b;\n  margin-bottom: 50px;\n  font-size: 20px;\n  line-height: 1.3; }\n", ""]);

// exports
